/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import prestashop from 'prestashop';
import $ from 'jquery';

prestashop.proquantity = prestashop.proquantity || {};

prestashop.proquantity = () => {
  /*wishlist also uses this so no need to do the check
  if(!sttheme.pro_quantity_input)
    return false;*/
  var spinnerSelector = $('input.pro_quantity');
  if(!spinnerSelector.length)
    return false;

  $.each(spinnerSelector, function (index, spinner) {
     $(spinner).TouchSpin({
      // verticalbuttons: !sttheme.is_mobile_device,
      verticalupclass: 'fto-plus-2',
      verticaldownclass: 'fto-minus',
      buttondown_class: 'btn btn-touchspin js-touchspin js-increase-product-quantity',
      buttonup_class: 'btn btn-touchspin js-touchspin js-decrease-product-quantity',
      min: ($(spinner).data('minimal-quantity') ? parseInt($(spinner).data('minimal-quantity'), 10) : 1),
      max: 1000000
    });
  });
};




// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js


// WEBPACK FOOTER //
// ./js/components/pro-quantity.js